import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "templateSection", "defaultSection", "clearField"]
  static values = { templateType: String }

  connect() {
    this.updateDisplay()
  }

  toggle() {
    this.updateDisplay()
  }

  updateDisplay() {
    const toggle = this.toggleTarget
    const templateSection = this.templateSectionTarget
    const defaultSection = this.defaultSectionTarget
    const clearField = this.clearFieldTarget

    if (toggle.checked) {
      // User wants to use custom template - don't clear
      templateSection.style.display = 'block'
      defaultSection.style.display = 'none'
      clearField.value = "0"
    } else {
      // User wants to use default template - clear custom template
      templateSection.style.display = 'none'
      defaultSection.style.display = 'block'
      clearField.value = "1"
    }
  }
} 